import { Link } from '../common';

export interface ShipmentLocationType {
  shipmentLocationTypeId: number;
  // tslint:disable-next-line:no-any
  links: Link | any;
}
